import React ,{useEffect} from "react";
import './Home.css';
import Header from "../Header/Header";
import Services from "../Services/Service";
import ServiceTwo from "../Services/ServiceTwo";
import ServiceThree from "../Services/ServiceThree";
import StatsSection from "../Percentage/Percentage";
import Footer from "../Footer/Footer";
import Carousal from "../Carousal/Carousal";
import ContactForm from "../ContactForm/ContactForm";
import Video from "../Video/Video";
import Pricing from "../Pricing/Pricing";
import TestimonialSlider from "../Testimonials/Testimonials";
import { useLocation } from 'react-router-dom';
export default function Home() {
    const location = useLocation();

    useEffect(() => {
        const scrollToSection = (delay = 0) => {
          const { scrollTo } = location.state || {};
          if (scrollTo) {
            const performScroll = () => {
              const section = document.getElementById(scrollTo);
              if (section) {
                const yOffset = -210;
                const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
              }
            };

            if (delay > 0) {
              setTimeout(performScroll, delay);
            } else {
              performScroll();
            }
          }
        };
    
        // First attempt almost immediately
        scrollToSection(100);
        // Second attempt after components have likely finished fetching data/rendering
        scrollToSection(600);

        // Clear state after a longer delay to ensure all attempts are done
        const clearTimer = setTimeout(() => {
          if (location.state?.scrollTo) {
            window.history.replaceState({}, document.title);
          }
        }, 1000);

        return () => clearTimeout(clearTimer);
      }, [location.state]);
    return (
        <div>
            <Header />
            <Carousal />
            <StatsSection />
            <Services />
            <Video />
            <Pricing />
            <ServiceTwo />
            <ServiceThree />
            {/* <PopularArticles /> */}
            <TestimonialSlider />
            <ContactForm />
            <Footer />
        </div>
    )

} 